import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

import { env } from '@/libs/env'
import { ExternalLinkModal } from '../external-link-modal'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export const FooterAgreement: React.FC<{}> = () => {
  const { i18n } = useTranslation()
  const lang = i18n.language
  const guestAppUrl = env('GUEST_APP_URL')

  return (
    <div css={footerAgreementStyle}>
      <p>
        <Trans
          i18nKey="TermsAndPolicy"
          components={{
            link_terms: <ExternalLinkModal src={`${guestAppUrl}/about-terms-of-use?lang=${lang}`} />,
            link_privacy: <ExternalLinkModal src={`${guestAppUrl}/about-privacy-policy?lang=${lang}`} />,
          }}
        />
      </p>
    </div>
  )
}

const footerAgreementStyle = css(
  {
    textAlign: 'center',
    color: '#272727',
    fontSize: 18,
    lineHeight: '27px',
    letterSpacing: '0.9px',
    marginTop: 24,
    marginBottom: 80,
    a: {
      color: '#f2a40b',
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 22, lineHeight: '33px', letterSpacing: '1.1px' },
  }),
)
